/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'button/waiting': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: '<mask id="svgicon_button_waiting_a" fill="#fff"><path pid="0" d="M5.136 5.136A9 9 0 112.5 11.5h1.62a7.379 7.379 0 102.162-5.218L5.136 5.136z"/></mask><path pid="1" d="M5.136 5.136A9 9 0 112.5 11.5h1.62a7.379 7.379 0 102.162-5.218L5.136 5.136z" _stroke="currentColor" stroke-width="3" mask="url(#svgicon_button_waiting_a)"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M10.6 12.24v.395l.345.193 3.795 2.125a.675.675 0 10.66-1.178l-3.45-1.931V6.775a.675.675 0 10-1.35 0v5.464z" _fill="currentColor"/><path pid="3" d="M3.704 6.578a.5.5 0 00.486.618l3.656.003a.5.5 0 00.394-.808L5.453 2.837a.5.5 0 00-.88.19l-.869 3.55z" _fill="currentColor"/>'
  }
})
